// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-modal=samurai-configuration-modal] .v--modal .panel[data-v-50b47fe9] {\n  margin-bottom: 0px;\n}\n[data-modal=samurai-configuration-modal] .v--modal .panel .panel-body[data-v-50b47fe9] {\n  padding-top: 1rem;\n}\n.config-list-table table tr:first-child td[data-v-50b47fe9] {\n  border-top: none;\n}\n.table-days-point-wrapper table tr td[data-v-50b47fe9] {\n  min-width: 90px;\n  padding-left: 1rem;\n}", ""]);
// Exports
module.exports = exports;
